import React from 'react';
export function Header() {
  return <header className="bg-purple-800 text-white py-2 px-4 text-center w-full" data-id="element-280">
      <p className="text-sm font-medium" data-id="element-281">ADVERTISEMENT</p>
      
    </header>;
}